<template>
  <restaurant-settings
    :currency="currency"
    :restaurant="restaurant"
    :user="user"
    :only-branch="true"
  />
</template>

<script lang="ts">
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import { IRestaurant } from '../../interfaces/IRestaurant';
  import SingleImageUploader from '../SingleImageUploader.vue';
  import { Globals } from '../../modules/Globals';
  import { vueData } from '../../VueData';
  import { AlertType } from '../../interfaces/IAlert';
  import { IBranch } from '../../interfaces/IBranch';
  import BranchesService from '../../api/services/branches.service';
  import { debounce } from '../../utils';
  import { ICurrency } from '../../interfaces/ICurrency';
  import { IHourRange } from '../../interfaces/IHourRange';
  import { OrderMode } from '../../enums/OrderEnums';
  import RestaurantSettings from './RestaurantSettings.vue';
  import { IUser } from '../../interfaces/IUser';

  @Component({
    components: { RestaurantSettings, SingleImageUploader },
  })
  export default class BranchSettings extends Vue {
    @Prop() restaurant: IRestaurant;
    @Prop() currency: ICurrency;
    @Prop() user: IUser;
  }
</script>
